export const mergeSkipUndefined = <T>(target: T, partial: Partial<T>): T => {
    const result = { ...target };

    for (const key in partial) {
        if (partial[key] !== undefined) {
            result[key] = partial[key] as T[Extract<keyof T, string>];
        }
    }

    return result;
};
